<script setup>
import Modal from "@/components/modals/Modal.vue";
import BaseButton from "@/components/shared/Button/BaseButton.vue";
import { SUPPORT_OTHER_EMAIL } from "@/constants.js";
import { computed } from "vue";
import CloseIcon from "@/components/svg-icons/CloseIcon.vue";
defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});
defineEmits(["update:modelValue"]);
const logo = computed(() => import.meta.env.VITE_CDN_ENDPOINT + "/images/api-connect-logo.png");

const supportEmail = SUPPORT_OTHER_EMAIL;
</script>
<template>
  <Modal
    :open="modelValue"
    :show-logo="false"
    :show-close-button="false"
    :close-on-outside-click="false"
    :rounded="false"
    max-width="max-w-[800px]"
    max-height="max-h-[320px]"
    content-padding-class="py-10 px-10"
  >
    <template #modalHeader>
      <div class="text-indigo-base flex flex-row justify-start h-[50px] bg-teal-accent absolute inset-0 px-5 py-3">
        <span class="font-bold ml-2">PROGRAM CHANGE, DEFERRAL, OR WITHDRAWAL</span>
        <button
          class="h-6 w-6 ml-auto"
          data-testid="close-modal-button-header"
          @click="$emit('update:modelValue', false)"
        >
          <span class="sr-only">Close</span>
          <CloseIcon size="23" stroke="#007f80" stroke-width="1.75" />
        </button>
      </div>
    </template>
    <template #modal-content>
      <div class="flex justify-center order-1 mt-10">
        <img :src="logo" data-cy="logoApiAbroad" class="h-10 object-contain logo" alt="API" />
      </div>
      <div class="text-indigo-base mt-6 ml-4 text-center">
        To change, defer, or withdraw from your program, please send an email to
        <a class="text-cyan-200" :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
        with details on your change request.
      </div>
    </template>
    <template #modal-footer>
      <div class="flex flex-row justify-center">
        <BaseButton
          class="px-7 min-w-[104px]"
          :rounded="false"
          :outlined="true"
          data-test-id="close-modal-button"
          @click="$emit('update:modelValue', false)"
          >CLOSE</BaseButton
        >
      </div>
    </template>
  </Modal>
</template>
